import * as React from 'react';
import styled from 'styled-components';
import { FontSizeProps, fontSize, textAlign, space, SpaceProps, TextAlignProps } from 'styled-system';
import { themeGet, media } from '@packages/ui';
import RichText from '@madebyconnor/rich-text-to-jsx';
import { INLINES } from '@contentful/rich-text-types';
import { ModuleText } from '@packages/common';

const colorPrimary = themeGet.colors('primary');

const textAlignFromProps = (props) => props?.textAlign ?? 'left';

// TODO: primarydark for active
const Container = styled.div<FontSizeProps & SpaceProps & TextAlignProps>`
  ${fontSize};
  ${textAlign}
  ${space}
  box-sizing: border-box;
  text-align: ${textAlignFromProps};

  a {
    text-decoration: underline;
    &:link,
    &:hover,
    &:focus,
    &:visited {
      color: ${colorPrimary};
    }
    &:active {
      color: ${themeGet.colors('primary')};
    }
  }

  p,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  > ul,
  > ol {
    margin: 0 0 20px;
    padding: 0;
  }

  ul,
  ol {
    color: ${themeGet.colors('sandDune')};
    padding-left: 35px;
    p {
      margin: 0;
      display: inline-block;
    }
    li {
      margin: 0;
      padding: 0;
      &::before {
        position: absolute;
        margin-left: -23px;
      }
    }
  }

  ul {
    list-style: none;

    li {
      &::before {
        content: '• ';
      }
    }
  }

  ol {
    list-style: none;
    counter-reset: li;

    li {
      &::before {
        counter-increment: li;
        content: counter(li) '.';
      }
    }
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-weight: ${themeGet.fontWeight('bold')};
  }

  h2 {
    font-size: ${themeGet.fontSize(8)};
  }

  h3 {
    font-size: ${themeGet.fontSize(7)};
  }

  h4,
  h5 {
    font-size: ${themeGet.fontSize(6)};
  }

  ${media.from.lg`
    h2 {
      font-size: ${themeGet.fontSize(12)};
    }
    h3 {
      font-size: ${themeGet.fontSize(8)};
    }
    h4,h5 {
      font-size: ${themeGet.fontSize(7)};
    }
  `}

  h6 {
    font-size: 85%;
    color: ${themeGet.colors('primary')};
  }
`;

const overrides = {
  // eslint-disable-next-line react/display-name
  [INLINES.HYPERLINK]: (props: any) => <a {...props} target="_self" rel="follow" />,
};

const padding = [2, 2, 4, 4, 6];

export type TextProps = ModuleText;

export const Text: React.FC<TextProps> = ({ textAlign, body }) => (
  <Container fontSize={7} px={padding} textAlign={textAlign}>
    <RichText richText={body} overrides={overrides} />
  </Container>
);
